<script setup lang="ts">
import { Ref, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import GbButton from '@/components/GbButton.vue'
import GbDialog from '@/components/GbDialog.vue'
import { toolkitUrls } from '@/util/links.js'
import { useRouter } from 'vue-router'
import { useRouterStore } from '@/router/router.store'

const router = useRouter()
const routerStore = useRouterStore()
const { lastNonPremiumPageVisited } = storeToRefs(routerStore)

const props = defineProps({
  fallbackRouteName: {
    type: String,
    default: 'AllFolders'
  },
  externalOpen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:externalOpen'])
const visibleRef: Ref<boolean> = ref(props.externalOpen)

const closeModal = function (): void {
  visibleRef.value = false
  emit('update:externalOpen', false)
}

watch(
  () => props.externalOpen,
  () => {
    visibleRef.value = props.externalOpen
  }
)

watch(
  () => visibleRef.value,
  () => {
    emit('update:externalOpen', visibleRef.value)
  }
)

const openSubscribeLink = function (): void {
  window.open(toolkitUrls.subscribe, '_blank')
}

const goBack = function (): void {
  closeModal()
  if (lastNonPremiumPageVisited.value) {
    router.push(lastNonPremiumPageVisited.value)
  } else {
    router.push({ name: props.fallbackRouteName })
  }
}
</script>

<template>
  <GbDialog
    dialogId="premium-action-modal"
    v-model:visible="visibleRef"
    header="Feature available with premium membership"
    :footer-buttons="true"
    @hide="goBack"
  >
    <template #bodyContent>
      <div class="flex flex-col gap-2">
        <p>
          You are not authorized to perform this action.
        </p>
      </div>
    </template>
    <template #footerButtonLeft>
      <GbButton
        type="button"
        gbTheme="bluePrimary"
        label="Request a quote"
        @click="openSubscribeLink"
      ></GbButton>
    </template>
    <template #footerButtonRight>
      <GbButton type="button" gbTheme="grayOutlineSecondary" label="OK" @click="goBack"></GbButton>
    </template>
  </GbDialog>
</template>
